import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/theme";
import { Preloader } from "@/components/Preloader";
import { CookieConsent } from "@/components/CookieConsent";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import Projeler from "@/pages/Projeler";
import ProjeDetay from "@/pages/ProjeDetay";
import TeslimKarnesi from "@/pages/TeslimKarnesi";
import Kurumsal from "@/pages/Kurumsal";
import Iletisim from "@/pages/Iletisim";
import Randevu from "@/pages/Randevu";
import Haberler from "@/pages/Haberler";
import Portal from "@/pages/Portal";
import NotFound from "@/pages/NotFound";
import AdminApp from "@/admin/AdminApp";

function App() {
  return (
    <ThemeProvider>
      <Preloader />
      <CookieConsent />
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projeler" element={<Projeler />} />
          <Route path="/proje/:slug" element={<ProjeDetay />} />
          <Route path="/teslim-karnesi" element={<TeslimKarnesi />} />
          <Route path="/kurumsal" element={<Kurumsal />} />
          <Route path="/iletisim" element={<Iletisim />} />
          <Route path="/randevu" element={<Randevu />} />
          <Route path="/haberler" element={<Haberler />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
